import { theme } from '../../lib/theme';

export default function Badge({ label, color, size = 'sm' }) {
  const sizes = {
    sm: { padding: '2px 8px', fontSize: 10 },
    md: { padding: '3px 10px', fontSize: 11 },
    lg: { padding: '4px 12px', fontSize: 12 },
  };
  const s = sizes[size] || sizes.sm;
  return (
    <span style={{
      display: 'inline-block',
      padding: s.padding,
      borderRadius: 12,
      fontSize: s.fontSize,
      fontWeight: 600,
      backgroundColor: `${color}18`,
      color,
      whiteSpace: 'nowrap',
    }}>
      {label}
    </span>
  );
}
